<template lang="pug">
	v-responsive(:class="componentClasses" :aspect-ratio="16/9")
		.static-map-holder(ref="holder" :style="`background-image: url(${background})`")
			img#forecast-overlay.forecast-overlay(:src="overlay" :style="regionOffset")
			svg-overlay(:svgtransform="svgtransform" :region="forecastRegion" :area="area" :urlquery="`#${type}-${hour}`")
</template>

<style lang="sass">
.areamap
	$self: &
	.static-map-holder
		background-size: cover
		display: block
		position: absolute
		top: 0px
		bottom: 0px
		left: 0px
		right: 0px

	.forecast-overlay
		position: absolute
		opacity: 0.8
		display: block
		width: 100%
		height: auto
</style>

<script>
import gql from 'graphql-tag';
import { latlngToPixels, forecastOverlayUrl, regionBounds } from './utils.js';
import SvgOverlay from './svg-overlay.vue';

const query = gql`
	query getAreaBounds($id: ID) {
		area(id: $id) {
			id
			measurepoints {
				forecastRegion
			}
			polymapBounds {
				svgtransform
				customBounds
			}
			polymapBoundsEurope: polymapBounds(region: "europe") {
				svgtransform
				customBounds
			}
		}
	}
`;

export default {
	components: {
		SvgOverlay
	},
	props: {
		hour: {
			type: Number,
			default: 144
		},
		weatherregion: {
			type: String,
			default: 'alps'
		},
		area: {
			type: String,
			required: true
		},
		mini: {
			type: Boolean,
			default: false
		},
		type: {
			type: String,
			default: 'snowforecast'
		}
	},
	data() {
		return {
			svgtransform: '',
			customBounds: null,
			forecastRegion: 'alps'
		};
	},
	async fetch() {
		await this.$graphClient
			.query({
				query,
				variables: {
					id: this.area
				}
			})
			.then(({ data }) => {
				this.forecastRegion = data.area.measurepoints[0].forecastRegion;
				if (this.forecastRegion === 'alps') {
					this.customBounds = data.area.polymapBounds.customBounds;
					this.svgtransform = data.area.polymapBounds.svgtransform;
				} else {
					this.customBounds = data.area.polymapBoundsEurope.customBounds;
					this.svgtransform = data.area.polymapBoundsEurope.svgtransform;
				}
			});
	},

	computed: {
		regionOffset() {
			if (!this.customBounds) {
				return {};
			}

			const boundRegion =
				this.forecastRegion === 'sauerland' ? 'europe' : this.forecastRegion;

			const contentWidth = this.$store.state.content_width.full_unpadded;

			const offsets = [
				latlngToPixels(
					regionBounds[boundRegion][0][0],
					regionBounds[boundRegion][0][1],
					(contentWidth * 9) / 16,
					contentWidth,
					this.customBounds
				),
				latlngToPixels(
					regionBounds[boundRegion][1][0],
					regionBounds[boundRegion][1][1],
					(contentWidth * 9) / 16,
					contentWidth,
					this.customBounds
				)
			];

			return {
				width: offsets[1].left - offsets[0].left + 'px',
				left: offsets[0].left + 'px',
				top: offsets[1].top + 'px'
			};
		},
		background() {
			return `https://static.wintersport.nl/images/destination-map/nl/${this.area}.png`;
		},
		overlay() {
			return forecastOverlayUrl(
				this.$store.state.rundate,
				this.type,
				this.hour,
				this.forecastRegion === 'sauerland' ? 'europe' : this.forecastRegion
			);
		},
		componentClasses() {
			const classes = [];
			classes.push('areamap');
			classes.push(`areamap-${this.forecastRegion}`);
			if (this.mini) {
				classes.push('areamap__mini');
			}

			return classes;
		}
	}
};
</script>
